<template>
  <div class="code-input-wrapper">
    <input
      v-for="(char, index) in characters"
      :key="index"
      v-model="characters[index]"
      @input="onInput($event, index)"
      @keydown="onKeyDown($event, index)"
      @paste="onPaste($event)"
      maxlength="1"
      pattern="[a-zA-Z0-9]*"
      :ref="'input-' + index"
      class="code-input text-uppercase"
    />
    <input type="hidden" :value="fullCode" />
  </div>
</template>

<script>
export default {
  name: 'CodeInput',
  props: {
    length: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      characters: Array(this.length).fill('')
    }
  },
  computed: {
    fullCode () {
      return this.characters.join('')
    }
  },
  methods: {
    onInput (event, index) {
      const value = event.target.value
      if (/^[a-zA-Z0-9]$/.test(value)) {
        this.characters[index] = value
        if (index < this.characters.length - 1) {
          this.$refs[`input-${index + 1}`][0].focus()
        }
        this.$emit('input', this.fullCode)
      } else {
        this.characters[index] = ''
      }
    },
    onKeyDown (event, index) {
      if (event.key === 'Backspace' && !this.characters[index] && index > 0) {
        this.$refs[`input-${index - 1}`][0].focus()
      }
    },
    onPaste (event) {
      const paste = (event.clipboardData || window.clipboardData).getData('text')
      if (/^[a-zA-Z0-9]+$/.test(paste)) {
        // Limit the pasted text to the number of inputs available
        const pasteCharacters = paste.slice(0, this.length).split('')
        this.characters = pasteCharacters.concat(
          Array(this.length - pasteCharacters.length).fill('')
        )
        this.$nextTick(() => {
          this.$refs[`input-${pasteCharacters.length - 1}`][0].focus()
        })
        this.$emit('input', this.fullCode)
      }
    }
  },
  watch: {
    length (newLength) {
      this.characters = Array(newLength).fill('')
    }
  }
}
</script>

<style scoped>
/* Your styles */
</style>
